/**
 * StreamCommentDTO entity class
 */

/**
 * StreamCommentDTOFactory
 * returns StreamCommentDTO entity class
 *
 * @class StreamCommentDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamCommentDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamCommentDTOFactory
 */
/* @ngInject */
export default function StreamCommentDTOFactory (Entity) {
  /* === StreamCommentDTO class === */

  /**
   * StreamCommentDTO model
   *
   * @class StreamCommentDTO
   * @classdesc StreamCommentDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamCommentDTO entity fields
   * @return {models.StreamCommentDTO} StreamCommentDTO entity
   */
  function StreamCommentDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamCommentDTO.prototype = Object.create(Entity.prototype)
  StreamCommentDTO.prototype.constructor = StreamCommentDTO

  /* === StreamCommentDTO instance methods & fields === */

  Object.assign(StreamCommentDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamCommentDTO#
     * @type {Object}
     */
    _fields: {
      type: String, /* SETRIX_STREAM_COMMENT_TYPES */
      message: String
    }
  })

  /**/

  /* === StreamCommentDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamCommentDTO, Entity)
  StreamCommentDTO._name = 'StreamCommentDTO'
  StreamCommentDTO.init()

  return StreamCommentDTO
}
